// src/calendrier/localizer.js
import { dateFnsLocalizer } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import fr from 'date-fns/locale/fr';

const locales = { fr };

const formats = {
  dateFormat: 'dd',
  dayFormat: 'eeee dd/MM',
  weekdayFormat: 'eeee',
  timeGutterFormat: 'HH:mm',
  monthHeaderFormat: 'MMMM yyyy',
  dayHeaderFormat: 'eeee d MMMM',
  dayRangeHeaderFormat: ({ start, end }, culture, local) =>
    `${local.format(start, 'd MMMM', culture)} – ${local.format(end, 'd MMMM yyyy', culture)}`,
  agendaHeaderFormat: ({ start, end }, culture, local) =>
    `${local.format(start, 'd MMMM', culture)} – ${local.format(end, 'd MMMM yyyy', culture)}`,
  agendaDateFormat: 'eeee d MMMM',
  agendaTimeFormat: 'HH:mm',
  agendaTimeRangeFormat: ({ start, end }, culture, local) =>
    `${local.format(start, 'HH:mm', culture)} – ${local.format(end, 'HH:mm', culture)}`,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
  getDay,
  locales,
  formats,
});

export default localizer;
